import TextField from "@/components/TextField";
import { Controller, useFormContext } from "react-hook-form";

type MaxAttendanceFieldProps = {
  label?: string;
  disabled?: boolean;
  displayValue?: string;
  helperText?: string;
} & (
  | {
      index: number;
      name?: never;
    }
  | {
      index?: never;
      name: string;
    }
);

const numericMask = (value: string): string => {
  return value.replace(/[^0-9]/g, "");
};

const MaxAttendanceField = ({
  index,
  name,
  label = "Max Registrants Allowed",
  disabled = false,
  displayValue,
  helperText = "Leave blank if no limit"
}: MaxAttendanceFieldProps) => {
  const { control } = useFormContext();
  const fieldName = name ?? `sessions.${index}.maxAttendance`;

  return (
    <div className="relative">
      <Controller
        name={fieldName}
        control={control}
        render={({ field: { onChange, value } }) => (
          <TextField
            label={label}
            className="w-full"
            value={displayValue ?? value}
            disabled={disabled}
            onChange={(e: Event) => {
              const maskedValue = numericMask((e.target as HTMLInputElement).value);
              onChange(maskedValue);
            }}
          />
        )}
      />
      <div className="text-sys-brand-on-surface text-body-small pt-1 pl-4">{helperText}</div>
    </div>
  );
};

export default MaxAttendanceField;
